import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";
import { FEATURE } from "@/config/features";

export const frontendNavData: NavProps["data"] = [
	{
		name: "sys.nav.dashboard",
		items: [
			{
				title: "sys.nav.workbench",
				path: "/workbench",
				icon: <Icon icon="local:ic-workbench" size="24" />,
			},
			{
				title: "sys.nav.calendar",
				path: "/calendar",
				icon: <Icon icon="solar:calendar-bold-duotone" size="24" />,
			},
			{
				title: "sys.nav.callout_search",
				path: "/callout-search",
				icon: <Icon icon="solar:map-point-search-bold-duotone" size="24" />,
			},
			{
				title: "sys.nav.phonebook",
				path: "/phonebook",
				icon: <Icon icon="solar:phone-bold-duotone" size="24" />,
				auth: ["view-phonebook"],
			},
			{
				title: "sys.nav.delinquent_contracts",
				path: "/delinquent-contracts",
				icon: <Icon icon="solar:danger-triangle-bold-duotone" size="24" />,
				auth: ["view-deliquent-contracts"],
			},
			// {
			// 	title: "sys.nav.analysis",
			// 	path: "/analysis",
			// 	icon: <Icon icon="local:ic-analysis" size="24" />,
			// },
		],
	},
	{
		name: "Ügyfélkezelő",
		items: [
			{
				title: "sys.nav.customers",
				path: "/customers",
				icon: <Icon icon="solar:users-group-rounded-bold-duotone" size="24" />,
				auth: ["view-customers"],
			},
			// FEJLESZTÉS ALATT (ügyfélportál) — élesen a kapu zárva, a menüpont
			// nem jelenik meg. Lásd config/features.ts.
			...(FEATURE.customerPortal
				? [
						{
							title: "Ügyfél-kérések",
							path: "/customer-change-requests",
							icon: <Icon icon="solar:inbox-in-bold-duotone" size="24" />,
							auth: ["view-customers"],
						},
						{
							title: "Portál belépések",
							path: "/portal-login-logs",
							icon: <Icon icon="mdi:shield-account" size="24" />,
							auth: ["view-customers"],
						},
					]
				: []),
			{
				title: "sys.nav.contracts",
				path: "/contracts",
				icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
				auth: ["view-contracts"],
			},
			// FEJLESZTÉS ALATT (sablon-szerkesztő) — élesen a kapu zárva, a menüpont
			// nem jelenik meg. Lásd config/features.ts.
			...(FEATURE.contractTemplates
				? [
						{
							title: "Sablon-szerkesztő (DEV)",
							path: "/contract-templates",
							icon: <Icon icon="solar:document-add-bold-duotone" size="24" />,
							auth: ["edit-contracts"],
						},
					]
				: []),
			{
				title: "Karbantartási áttekintő",
				path: "/maintenance-overview",
				icon: <Icon icon="solar:calendar-mark-bold-duotone" size="24" />,
				auth: ["view-maintenance-overview"],
			},
			{
				title: "Extra szolgáltatások",
				path: "/extra-services",
				icon: <Icon icon="solar:list-check-bold-duotone" size={24} />,
				auth: ["view-contracts"],
			},
			{
				title: "Hibabejelentő",
				path: "/complaints",
				icon: <Icon icon="solar:danger-triangle-bold-duotone" size="24" />,
				auth: ["view-customer-complaints", "view-all-customer-complaints"],
			},
			{
				title: "GSM modulok",
				path: "/gsm-modules",
				icon: <Icon icon="solar:sim-card-bold-duotone" size="24" />,
				auth: ["view-gsm-modules"],
			},
			{
				title: "sys.nav.tavfelugyelet_elesites",
				path: "/tavfelugyelet-elesites",
				icon: <Icon icon="solar:bell-bing-bold-duotone" size="24" />,
				auth: ["view-tavfelugyelet-elesites"],
			},
		],
	},
	{
		name: "Járműkezelő",
		items: [
			{
				title: "Km-diktálás",
				path: "/km-dictation",
				icon: <Icon icon="mdi:speedometer" size="24" />,
				auth: ["view-km-dictation"],
			},
			{
				title: "Elmaradt km",
				path: "/km-overdue",
				icon: <Icon icon="mdi:alert-circle-outline" size="24" />,
				auth: ["view-km-overdue"],
			},
			{
				title: "sys.nav.vehicles",
				path: "/vehicles",
				icon: <Icon icon="solar:garage-bold-duotone" size="24" />,
				auth: ["view-vehicles"],
			},
			{
				title: "sys.nav.vehicle_notifications",
				path: "/vehicle-notifications",
				icon: <Icon icon="solar:bell-bing-bold-duotone" size="24" />,
				auth: ["view-vehicle-notifications"],
			},
			{
				title: "sys.nav.vehicle_notification_categories",
				path: "/vehicle-notification-categories",
				icon: <Icon icon="solar:inbox-bold-duotone" size="24" />,
				auth: ["view-vehicle-notification-categories"],
			},
		],
	},
	{
		name: "Projektkezelés",
		items: [
			{
				title: "sys.nav.projects",
				path: "/projects",
				icon: <Icon icon="solar:clipboard-list-bold-duotone" size="24" />,
				auth: ["view-projects", "view-all-project"],
			},
			{
				title: "sys.nav.task_statuses",
				path: "/task-statuses",
				icon: <Icon icon="solar:list-bold-duotone" size="24" />,
				auth: ["view-task-statuses"],
			},
			{
				title: "sys.nav.tasks",
				path: "/tasks",
				icon: <Icon icon="solar:checklist-bold-duotone" size="24" />,
				auth: ["view-tasks"],
			},
		],
	},
	{
		name: "Partnerkezelő",
		items: [
			{
				title: "sys.nav.partners",
				path: "/partners",
				icon: <Icon icon="solar:users-group-two-rounded-bold-duotone" size="24" />,
				auth: ["view-partners"],
			},

			{
				title: "sys.nav.service_areas",
				path: "/service-areas",
				icon: <Icon icon="solar:map-point-bold-duotone" size="24" />,
				auth: ["view-service-areas"],
			},
		],
	},
	{
		name: "Számlák",
		items: [
			{
				title: "sys.nav.invoices",
				path: "/invoices",
				icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
				auth: ["view-invoices"],
			},
			{
				title: "sys.nav.approved_invoices",
				path: "/invoices/approved",
				icon: <Icon icon="solar:check-circle-bold-duotone" size="24" />,
				auth: ["view-invoices"],
			},
			{
				title: "sys.nav.paid_invoices",
				path: "/invoices/paid",
				icon: <Icon icon="solar:wallet-money-bold-duotone" size="24" />,
				auth: ["view-invoices"],
			},
		],
	},
	{
		name: "Viszonteladók",
		items: [
			{
				title: "Viszonteladók",
				path: "/resellers",
				icon: <Icon icon="solar:shop-2-bold-duotone" size="24" />,
				auth: ["view-resellers"],
			},
		],
	},
	{
		name: "Jutalékelszámolás",
		items: [
			{
				title: "Jutalékelszámolás",
				path: "/commissions",
				icon: <Icon icon="solar:calculator-bold-duotone" size="24" />,
				auth: ["view-commissions"],
			},
		],
	},
	{
		name: "Feladatkezelés",
		items: [
			{
				title: "Feladatkezelés",
				path: "/task-management",
				icon: <Icon icon="solar:clipboard-list-bold-duotone" size="24" />,
				auth: ["view-non-project-tasks"],
			},
		],
	},
	{
		name: "Munkavállalók",
		items: [
			{
				title: "Munkavállalók",
				path: "/employees",
				icon: <Icon icon="solar:users-group-rounded-bold-duotone" size="24" />,
				auth: ["view-employees"],
			},
		],
	},
	{
		name: "Beállítások",
		items: [
			{
				title: "Jogosultságok",
				path: "/roles",
				icon: <Icon icon="solar:shield-keyhole-bold-duotone" size="24" />,
				auth: ["view-roles"],
			},
			{
				title: "Felhasználók",
				path: "/users",
				icon: <Icon icon="solar:users-group-rounded-bold-duotone" size="24" />,
				auth: ["view-users"],
			},
			{
				title: "Hátralékos e-mail címek",
				path: "/deliquent-payment-mail-addresses",
				icon: <Icon icon="solar:letter-bold-duotone" size="24" />,
				auth: ["view-deliquent-payment-mail-addresses"],
			},
			{
				title: "Email napló",
				path: "/email-logs",
				icon: <Icon icon="solar:mailbox-bold-duotone" size="24" />,
				auth: ["view-email-logs"],
			},
			{
				title: "Adatbázis mentések",
				path: "/backup-destinations",
				icon: <Icon icon="solar:database-bold-duotone" size="24" />,
				auth: ["inventory-admin"],
			},
		],
	},
	{
		name: "Cégiratok",
		items: [
			{
				title: "Cégiratok",
				path: "/company-documents",
				icon: <Icon icon="solar:document-bold-duotone" size="24" />,
				auth: ["view-company-documents"],
			},
		],
	},
	{
		name: "Napi események",
		items: [
			{
				title: "Napi események",
				path: "/daily-events",
				icon: <Icon icon="solar:calendar-mark-bold-duotone" size="24" />,
				auth: ["view-daily-events"],
			},
		],
	},
	{
		name: "Árajánlatok",
		items: [
			{
				title: "Árajánlatok",
				path: "/price-quotes",
				icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
				auth: ["view-price-quotes"],
			},
		],
	},
	{
		name: "Munkalapok",
		items: [
			{
				title: "Munkalapok",
				path: "/work-sheets",
				icon: <Icon icon="solar:clipboard-text-bold-duotone" size="24" />,
				auth: ["view-work-sheets"],
			},
		],
	},
	{
		name: "Felmérés",
		items: [
			{
				title: "Felmérési lapok",
				path: "/survey-sheets",
				icon: <Icon icon="solar:checklist-minimalistic-bold-duotone" size="24" />,
				auth: ["view-survey-sheets"],
			},
			{
				title: "Termékek",
				path: "/products",
				icon: <Icon icon="solar:box-bold-duotone" size="24" />,
				auth: ["view-products"],
			},
		],
	},
	{
		name: "E-mail",
		items: [
			// FEJLESZTÉS ALATT (levelező) — élesen a kapu zárva, a menüpont
			// nem jelenik meg. Lásd config/features.ts.
			...(FEATURE.mailClient
				? [
						{
							title: "Levelezés",
							path: "/mail",
							icon: <Icon icon="solar:letter-bold-duotone" size="24" />,
							auth: ["use-mail-client"],
						},
					]
				: []),
		],
	},
	{
		name: "Adatbekérők (DEV)",
		items: [
			// FEJLESZTÉS ALATT (adatbekérők) — élesen a kapu zárva, a menüpont
			// nem jelenik meg. Lásd config/features.ts.
			...(FEATURE.dataRequests
				? [
						{
							title: "Beérkezett adatbekérők",
							path: "/data-requests",
							icon: <Icon icon="mdi:clipboard-text-outline" size="24" />,
							auth: ["view-data-requests"],
						},
						{
							title: "Adatbekérő típusok",
							path: "/data-request-types",
							icon: <Icon icon="mdi:form-select" size="24" />,
							auth: ["view-data-request-types"],
						},
					]
				: []),
			// Fejlesztés alatt: élesen a /data-requests/outbox végpont nem létezik,
			// ezért a menüpont 404-es oldalra vitt. Lásd config/features.ts.
			...(FEATURE.dataRequestOutbox
				? [
						{
							title: "Kiküldendő adatbekérők",
							path: "/data-requests/outbox",
							icon: <Icon icon="mdi:email-fast-outline" size="24" />,
							auth: ["view-data-requests"],
						},
					]
				: []),
		],
	},
	{
		name: "Raktárkezelés",
		items: [
			{
				title: "Raktárkészlet",
				path: "/inventory",
				icon: <Icon icon="mdi:warehouse" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Bevételezés",
				path: "/inventory/receipt",
				icon: <Icon icon="mdi:package-variant-plus" size="24" />,
				auth: ["create-inventory-receipt"],
			},
			{
				title: "Kiadás / Foglalás",
				path: "/inventory/issue",
				icon: <Icon icon="mdi:package-down" size="24" />,
				auth: ["create-inventory-issue"],
			},
			{
				title: "Szerelők",
				path: "/inventory/technicians",
				icon: <Icon icon="mdi:account-hard-hat" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Szerelő készletek",
				path: "/inventory/technician-stocks",
				icon: <Icon icon="mdi:account-wrench" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Hibás termékek",
				path: "/inventory/defective",
				icon: <Icon icon="mdi:alert-octagon" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Javított raktár",
				path: "/inventory/repaired",
				icon: <Icon icon="mdi:tools" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Selejtezett tételek",
				path: "/inventory/scrapped",
				icon: <Icon icon="mdi:delete-alert" size="24" />,
				auth: ["view-inventory"],
			},
			{
				title: "Anyagmozgás napló",
				path: "/inventory/logs",
				icon: <Icon icon="mdi:clipboard-text-clock" size="24" />,
				auth: ["view-inventory-logs"],
			},
			{
				title: "Kategóriák",
				path: "/inventory/categories",
				icon: <Icon icon="mdi:folder-multiple" size="24" />,
				auth: ["manage-inventory-categories"],
			},
			{
				title: "Beszállítók",
				path: "/inventory/suppliers",
				icon: <Icon icon="mdi:truck-delivery" size="24" />,
				auth: ["manage-inventory-categories"],
			},
			{
				title: "Raktári helyek",
				path: "/inventory/locations",
				icon: <Icon icon="mdi:map-marker-multiple" size="24" />,
				auth: ["manage-inventory-categories"],
			},
			{
				title: "Leltár",
				path: "/inventory/stocktake",
				icon: <Icon icon="mdi:clipboard-check" size="24" />,
				auth: ["inventory-admin"],
			},
			{
				title: "Riportok",
				path: "/inventory/reports",
				icon: <Icon icon="mdi:chart-bar" size="24" />,
				auth: ["view-inventory-reports"],
			},
		],
	},
	{
		name: "Fejlesztés",
		items: [
			{
				title: "Bejelentések listája",
				path: "/developer-issues",
				icon: <Icon icon="solar:list-check-bold-duotone" size="24" />,
			},
			{
				title: "Fejlesztői Hibabejelentő",
				path: "/developer-bug-report",
				icon: <Icon icon="solar:bug-bold-duotone" size="24" />,
			},
		],
	},
];
